
    (() => {
  const initialized = new WeakSet();

  // ---- Datumová logika: spočítat jednou pro celou stránku
  const NOW = new Date();
  function nextDispatch(now = NOW){
    const d = new Date(now), day = d.getDay(), hour = d.getHours();
    if ((day === 2 || day === 4) && hour < 14) return d;               // Út/Čt do 14:00 => expedice dnes
    let add; if (day < 2) add = 2 - day; else if (day < 4) add = 4 - day; else add = (7 - day) + 2;
    d.setDate(d.getDate() + add); return d;
  }
  function nextDelivery(dispatchDate){
    const dd = new Date(dispatchDate);
    while (dd.getDay() !== 3 && dd.getDay() !== 5) dd.setDate(dd.getDate() + 1); // st/pá
    return dd;
  }
  const DISPATCH = nextDispatch(NOW);
  const DELIVERY = nextDelivery(DISPATCH);
  const TODAY0 = new Date(NOW); TODAY0.setHours(0,0,0,0);
  const DELIV0 = new Date(DELIVERY); DELIV0.setHours(0,0,0,0);
  const IS_TMR = Math.round((DELIV0 - TODAY0) / 86400000) === 1;
  const formatDate = (d) => `${d.getDate()}.${d.getMonth()+1}.`;
  const weekdayCz  = (d) => d.toLocaleDateString('cs-CZ', { weekday:'long' });

  function inStock(v){ return !!v && (v.available || v.inventory_policy === "continue" || (v.inventory_quantity ?? 0) > 0); }

  function initEstimatedDelivery(root){
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const uid    = root.id.replace('pb-ed-','');
    const textEl = document.getElementById(`pb-ed-text-${uid}`);
    const dataEl = document.getElementById(`pb-ed-data-${uid}`);
    if (!textEl || !dataEl) return;

    let product;
    try { product = JSON.parse(dataEl.textContent || "{}"); } catch { product = {}; }
    const variants = Array.isArray(product?.variants) ? product.variants : [];
    const VARS = {};
    for (let i=0;i<variants.length;i++) VARS[String(variants[i].id)] = variants[i];

    const cache = {};
    function messageFor(variantId){
      const key = String(variantId ?? '');
      if (cache[key]) return cache[key];
      const v = VARS[key];
      let msg;
      if (!inStock(v)) {
        msg = "Brzy opět skladem – do 14 dnů";
      } else {
        const wd = weekdayCz(DELIVERY);
        const pred = (wd === "středa" || wd === "čtvrtek") ? "ve" : "v";
        const wdSk = (wd === "středa") ? "středu" : wd;
        const df = formatDate(DELIVERY);
        msg = IS_TMR ? `Skladem – doručíme již zítra ${df}` : `Skladem – doručíme již ${pred} ${wdSk} ${df}`;
      }
      cache[key] = msg; return msg;
    }
    function updateByVariantId(variantId){
      textEl.textContent = variantId ? messageFor(String(variantId)) : "Brzy opět skladem – do 14 dnů";
    }

    const container = root.closest('.shopify-section') || document.body;

    // Horizon: hlavní event
    function sameProduct(eProductId){
      const pidA = String(eProductId ?? '');
      const pidB = String(product?.id ?? '');
      return !pidA || !pidB || pidA === pidB;
    }
    const onVariantUpdate = (e) => {
      if (!sameProduct(e?.detail?.data?.productId || e?.detail?.productId)) return;
      updateByVariantId(e?.detail?.resource?.id);
    };
    container.addEventListener('variant:update', onVariantUpdate, { passive:true });

    // Fallback: input[name="id"]
    const form    = container.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    let   idInput = form?.querySelector('input[name="id"]');
    const wireIdInput = (el) => {
      if (!el || el.dataset.pbEdWired === "1") return;
      el.dataset.pbEdWired = "1";
      const onChange = () => updateByVariantId(el.value);
      el.addEventListener('change', onChange, { passive:true });
      new MutationObserver(onChange).observe(el, { attributes:true, attributeFilter:['value'] });
    };

    // Inicializace
    const urlVariantId = new URLSearchParams(window.location.search).get('variant');
    if (urlVariantId) updateByVariantId(urlVariantId);
    else if (idInput?.value) updateByVariantId(idInput.value);
    else if (variants.length) updateByVariantId((variants.find(inStock) || variants[0]).id);

    wireIdInput(idInput);

    // Pozdější mount inputu
    const waitForIdInput = new MutationObserver(() => {
      if (idInput && idInput.isConnected) return;
      idInput = (form || container).querySelector?.('form[action*="/cart/add"] input[name="id"]')
             || document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (idInput) { wireIdInput(idInput); if (idInput.value) updateByVariantId(idInput.value); waitForIdInput.disconnect(); }
    });
    waitForIdInput.observe(container, { subtree:true, childList:true });

    // Post-hydratační sync (pokud Horizon po mountu přepne variantu)
    (window.requestAnimationFrame || setTimeout)(() => {
      if (idInput?.value) updateByVariantId(idInput.value);
    }, 0);
  }

  function initAll(){ document.querySelectorAll('.pb-ed').forEach(initEstimatedDelivery); }

  // První načtení
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once:true });
  } else {
    initAll();
  }

  // Dynamické přidání (Ajax/sections)
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.addedNodes) {
        m.addedNodes.forEach(n => {
          if (n.nodeType === 1) {
            if (n.classList?.contains('pb-ed')) initEstimatedDelivery(n);
            n.querySelectorAll?.('.pb-ed').forEach(initEstimatedDelivery);
          }
        });
      }
    }
  });
  mo.observe(document.documentElement, { childList:true, subtree:true });

  // Podpora pro Theme Editor
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();

/* PB: Subcollection horizontal menu — init + zachování scrollu mezi prokliky */
document.addEventListener("DOMContentLoaded", function () {
  var scrollContainer = document.querySelector('.subcollection-scroll');
  if (!scrollContainer) return;

  // Spustit jen pokud je obsah širší než viewport
  if (scrollContainer.scrollWidth <= scrollContainer.clientWidth + 1) return;

  // Unikátní klíč podle typu menu (muži/ženy)
  var menuKey = 'subcollectionScrollLeft_' + (scrollContainer.dataset.menuType || 'default');
  var savedScroll = sessionStorage.getItem(menuKey);
  if (savedScroll !== null) {
    scrollContainer.scrollLeft = parseInt(savedScroll, 10);
  }
  var links = scrollContainer.querySelectorAll('a');
  links.forEach(function(link) {
    link.addEventListener('click', function() {
      sessionStorage.setItem(menuKey, scrollContainer.scrollLeft);
    });
  });
});

// Sekce se slevou pro čtenáře – Reader Offer: minimal copy-on-click + guard (načte se jen se snippetem)
(() => {
  if (window.__pbReaderOfferInit) return; window.__pbReaderOfferInit = true;

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.pb-reader-offer__copy');
    if (!btn) return;

    const root = btn.closest('.pb-reader-offer');
    if (!root) return;

    const input = root.querySelector('.pb-reader-offer__codeinput');
    const code = (input?.value || root.getAttribute('data-discount') || '').trim();
    if (!code) return;

    const notify = () => {
      const fb = root.querySelector('.pb-reader-offer__feedback');
      if (fb) { fb.hidden = false; fb.textContent = 'Kód byl zkopírován.'; setTimeout(() => { fb.hidden = true; fb.textContent = ''; }, 2000); }
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(code).then(notify);
    } else {
      const ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch(_) {}
      document.body.removeChild(ta); notify();
    }
  });
})();